import { FC } from 'react';
import { CardType } from "./types"
import {
    IconDots,
    IconInfoCircle,
} from "@tabler/icons-react";
import Image from "../../../../../components/Image";

// @ts-ignore
const Grid: FC<CardType> = ({
    unit,
    estado,
    idProject,
    toggleBidder,
    openDrop,
    setOpenDrop,
    dropdownRef,
    handleSelect,
    handleOpen,
    handleCreateBooking,
}) => {
    const { base_price, cover, id, name, status, landlordInfo, updated_at, price_by_area, project_supports_multiple_bookings, landlords_booked } = unit;

    return (
        <div className='p-4 rounded-[10px] bg-white border border-[#E0E0E0] h-full flex flex-col justify-around size-full gap-2'>
            <div className="w-full flex relative gap-4">
                <div className="aspect-square rounded-md overflow-hidden border size-20 min-w-20">
                    <Image src={cover} alt={name} />
                </div>
                <div>
                    <div className="w-full pb-2">
                        <span className={`px-2 py-0.5 text-xs font-medium rounded-full ${estado[status]?.class || ""}`}>
                            {estado[status]?.name || ""}
                        </span>
                    </div>
                    <h1 className="text-lg font-semibold text-[#212121] break-all leading-[1.4] line-clamp-3">{name}</h1>
                </div>
                {status === "assigned" && (
                    <div className="absolute -right-3 -top-3 text-left" ref={dropdownRef}>
                        <button
                            onClick={() => setOpenDrop(!openDrop)}
                            className="inline-flex justify-between w-full rounded-md px-2 py-2 bg-white text-sm font-medium text-[#9E9E9E] hover:bg-gray-50 transition"
                        >
                            <IconDots />
                        </button>

                        <div
                            className={`absolute right-0 mt-2 w-52 rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 transition-all duration-200 origin-top-right transform z-50 ${openDrop
                                ? "opacity-100 scale-100"
                                : "opacity-0 scale-95 pointer-events-none"
                                }`}
                        >
                            <div className="py-1 text-sm text-[#212121] font-medium">
                                <button
                                    className="w-full text-left px-4 py-2 hover:bg-gray-100"
                                    onClick={() => handleSelect("assigned")}
                                >
                                    Liberar unidad
                                </button>
                            </div>
                        </div>
                    </div>
                )}

                {(status === "created" ||
                    status === "disabled" ||
                    status === "available") && (
                        <div className="absolute -right-2 -top-2 text-left" ref={dropdownRef}>
                            <button
                                onClick={() => setOpenDrop(!openDrop)}
                                className="inline-flex justify-between w-full rounded-md px-2 py-2 bg-white text-sm font-medium text-[#9E9E9E] hover:bg-gray-50 transition"
                            >
                                <IconDots />
                            </button>

                            <div
                                className={`absolute right-0 mt-2 w-52 rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 transition-all duration-200 origin-top-right transform z-50 ${openDrop
                                    ? "opacity-100 scale-100"
                                    : "opacity-0 scale-95 pointer-events-none"
                                    }`}
                            >
                                {(status === "created" || status === "disabled") && (
                                    <div className="py-1 text-sm text-[#212121] font-medium">
                                        <button
                                            className="w-full text-left px-4 py-2 hover:bg-gray-100"
                                            onClick={() => handleSelect("created")}
                                        >
                                            Habilitar unidad
                                        </button>
                                    </div>
                                )}
                                {status === "available" && (
                                    <>
                                        <div className="py-1 text-sm text-[#212121] font-medium">
                                            <button
                                                className="w-full text-left px-4 py-2 hover:bg-gray-100"
                                                onClick={handleCreateBooking}
                                            >
                                                Crear una pre-reserva
                                            </button>
                                        </div>
                                        <div className="py-1 text-sm text-[#212121] font-medium">
                                            <button
                                                className="w-full text-left px-4 py-2 hover:bg-gray-100"
                                                onClick={() => handleSelect("available")}
                                            >
                                                Deshabilitar unidad
                                            </button>
                                        </div>
                                    </>
                                )}
                            </div>
                        </div>
                    )}
            </div>
            <>
                {status === "pre_booked" ? (
                    <>
                        {project_supports_multiple_bookings ? (
                            <button onClick={() => handleOpen(idProject, id)} className="mx-1 hover:bg-black/5 rounded-md duration-300 px-0.5 w-[fit-content]" >
                                <div className="flex items-start gap-1 text-left font-medium">
                                    <IconInfoCircle color="#212121" className='size-5 min-w-5' />
                                    <span className='text-sm text-[#212121] line-clamp-2 pt-[1px]'>{landlords_booked} pre-reservas</span>
                                </div>
                            </button>
                        ) : (
                            <>
                                {landlordInfo && landlordInfo.id && (
                                    <button onClick={() => handleOpen(idProject, id)} className="mx-1 hover:bg-black/5 rounded-md duration-300 px-0.5  w-[fit-content]" >
                                        <div className="flex items-start gap-1 text-left font-medium">
                                            <IconInfoCircle color="#212121" className='size-5 min-w-5' />
                                            <span className='text-sm text-[#212121] line-clamp-2 pt-[1px]'>{landlordInfo.name}</span>
                                        </div>
                                    </button>
                                )}
                            </>
                        )}
                    </>
                ) : (
                    <>
                        {(status === "taken" ||
                            status === "assigned" ||
                            status === "signing_promise") && (
                                <>
                                    {landlordInfo && landlordInfo.id && (
                                        <button onClick={toggleBidder} className="mx-1 hover:bg-black/5 rounded-md duration-300 p-0.5">
                                            <div className="text-[#212121] text-sm flex items-start gap-1 text-left font-medium">
                                                <IconInfoCircle color="#212121" className='size-5 min-w-5' />
                                                {landlordInfo.name}
                                            </div>
                                        </button>
                                    )}
                                </>
                            )}
                    </>
                )}
            </>
            <div className='mt-auto'>
                <hr className="mb-2" />
                <div className="w-full">
                    <p className="text-sm lg:text-base font-semibold text-[#212121] flex flex-row gap-2 justify-between">
                        <span>Precio:</span>
                        <span className="font-normal text-[#757575]">{base_price}</span>
                    </p>
                    <p className="text-sm lg:text-base font-semibold text-[#212121] flex flex-row gap-2 justify-between">
                        <span>Precio por m²:</span>
                        <span className="font-normal text-[#757575]">
                            {price_by_area}
                        </span>
                    </p>
                    <p className="text-sm lg:text-base font-semibold text-[#212121] flex flex-row gap-2 justify-between">
                        <span>Actualización:</span>
                        <span className="font-normal text-[#757575]">{updated_at}</span>
                    </p>
                </div>
            </div>
        </div >
    )
}

export default Grid;